import Button from 'components/common/Button';
import Card from 'components/common/Card';
import Heading from 'components/common/Typography/Heading';
import styled from 'styled-components';
import { style } from 'utils/constants/style';

interface IProps {
  span?: number;
  fr?: number;
}

export const Wrapper = styled.div`
  margin-top: 31px;

  @media (max-width: 575px) {
    margin-top: 25px;
  }
`;

export const CardWrapperMain = styled(Card)`
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  background: transparent;
  box-shadow: none;
  margin-bottom: 13px;
  flex-flow: wrap;
  @media (max-width: 876px) {
    justify-content: center;
  }
`;

export const CardImg = styled.div`
  position: relative;
  height: 157px;
  img {
    border-radius: 8px 8px 0 0;
    object-fit: cover;
  }
  span {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const CardWrapper = styled(Card)`
  width: 100%;
  margin: 0 8px 8px 0;
  @media (max-width: 876px) {
    width: 100%;
  }
  @media (max-width: 575px) {
    width: 100%;
    margin: 0 0 8px 0;
  }
`;

export const RatingWrapper = styled.div`
  position: absolute;
  top: 5px;
  left: 10px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  color: #e0e0e4;
  svg {
    width: 12px;
  }
`;

export const AddressWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  & > svg {
    height: 20px;
    width: 20px;
  }
  button {
    font-weight: 600;
    font-size: 12px;
    padding: 8px 11px;
  }
`;
export const RouteAddress = styled.div`
  width: 75%;
`;

export const Address = styled.address`
  font-style: normal;
  font-size: ${(props) => props.theme.typography.fontSize.f3};
  color: ${(props) => props.theme.colors.blue};
  margin-left: 5px;
  font-weight: ${(props) => props.theme.typography.fontWeight.regular};
`;

export const RouteName = styled.address`
  font-size: 14px;
  color: #000;
  font-weight: 600;
  font-style: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const RouteKm = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  span {
    font-size: 12px;
    font-weight: 500;
    color: #000;
  }
  svg {
    height: 14px;
    width: 14px;
    margin-right: 5px;
  }
`;
export const RouteDistance = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;
export const RouteTime = styled.div`
  display: flex;
  align-items: center;
`;
